import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  public disabledNextPage: boolean = true;
  public disabledPreviousPage: boolean = true;
  public _currentPage = 0;

  @Input() isLoading: boolean = false;
  @Input() set hasNext(flat: boolean){
    this.disabledNextPage = !flat;
  }

  @Input() set currentPage(num: number) {
    this._currentPage = num;
    if (num > 0) {
      this.disabledPreviousPage = false;
    } else {
      this.disabledPreviousPage = true;
    }
  }

  @Output() changePage: EventEmitter<number> = new EventEmitter<number>();

  onNextPage(): void {
    if (!this.disabledNextPage) {
        this._currentPage += 1;
        this.changePage.emit(this._currentPage);
    }
  }

  onPreviousPage(): void {
    if (!this.disabledPreviousPage) {
        this._currentPage -= 1;
        this.changePage.emit(this._currentPage);
    }
  }
}
